var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToplogo(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 189.05,
    height: 18.057,
    viewBox: "0 0 189.05 18.057",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4757",
    "data-name": "Group 4757",
    transform: "translate(-53.989 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4668",
    "data-name": "Group 4668",
    transform: "translate(53.989 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DentaliD",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_209",
    "data-name": "Group 209",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2218",
    "data-name": "Path 2218",
    d: "M363.541,247.264a.776.776,0,0,1,0,1.546H357.68a.776.776,0,0,1,0-1.546ZM360.495,232.3a.776.776,0,0,1,0-1.546h5.861a.776.776,0,0,1,0,1.546Zm.126,2.585a.776.776,0,0,1,0,1.546h-6.564a.777.777,0,0,1,0-1.546Zm-4.464,5.665a.776.776,0,0,1,0-1.546h11.721a.776.776,0,0,1,0,1.546Zm7.268,4.131a.776.776,0,0,1,0-1.546h6.533a.776.776,0,0,1,0,1.546Z",
    transform: "translate(-351.719 -230.753)",
    fill: "#20c3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2219",
    "data-name": "Path 2219",
    d: "M362.963,247.264a.773.773,0,1,1-.774.773A.773.773,0,0,1,362.963,247.264ZM353.425,232.3a.773.773,0,1,1,.773-.773A.773.773,0,0,1,353.425,232.3Zm6.328,2.585a.773.773,0,1,1-.774.773A.773.773,0,0,1,359.753,234.884Zm7,0a.767.767,0,1,1,0,1.535h-3.9a.767.767,0,1,1,0-1.535Zm.982,4.119a.773.773,0,1,1-.774.773A.774.774,0,0,1,367.732,239Zm-11.086,5.677a.773.773,0,1,1,.774-.773A.773.773,0,0,1,356.647,244.679Zm-7.136,0a.773.773,0,1,1,0-1.546h4.042a.773.773,0,0,1,0,1.546Zm-.855-4.131a.773.773,0,1,1,.774-.773A.773.773,0,0,1,348.656,240.549Z",
    transform: "translate(-347.882 -230.753)",
    fill: "#50f5ae"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4729",
    "data-name": "Group 4729",
    transform: "translate(88.33 2.071)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1661",
    "data-name": "Group 1661",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1649",
    "data-name": "Group 1649",
    transform: "translate(82.539 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2359",
    "data-name": "Path 2359",
    d: "M631.855,266.186a2.354,2.354,0,0,1,1.248.306,3.008,3.008,0,0,1,1,1.186l6.506,11.815a.4.4,0,0,1,.061.327c-.041.081-.123.123-.286.123h-2.5a.436.436,0,0,1-.45-.266l-1.411-2.535-1.228-2.269-3.13-5.764a.279.279,0,0,0-.225-.143h-.1a.278.278,0,0,0-.225.143l-3.089,5.764-1.227,2.269-1.371,2.535a.453.453,0,0,1-.45.266h-2.557c-.164,0-.266-.041-.307-.123a.492.492,0,0,1,.061-.327l6.444-11.815a3.361,3.361,0,0,1,.962-1.186,2,2,0,0,1,1.1-.306Z",
    transform: "translate(-622.109 -266.186)",
    fill: "#111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2358",
    "data-name": "Path 2358",
    d: "M648.87,297.833l-3.132,5.425a.151.151,0,0,0,.131.227h6.264a.151.151,0,0,0,.131-.227l-3.132-5.425A.151.151,0,0,0,648.87,297.833Z",
    transform: "translate(-639.714 -289.729)",
    fill: "#20c3ff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2360",
    "data-name": "Path 2360",
    d: "M718.824,266.186c.307,0,.45.143.45.429v7.849a5.915,5.915,0,0,0,.123,1.308,1.652,1.652,0,0,0,.429.818,1.515,1.515,0,0,0,.777.429,5.525,5.525,0,0,0,1.268.123h7.979a.38.38,0,0,1,.43.429v1.942a.38.38,0,0,1-.43.429H721.77a9.981,9.981,0,0,1-2.537-.286,3.837,3.837,0,0,1-1.7-.879,3.708,3.708,0,0,1-.982-1.615,9.169,9.169,0,0,1-.286-2.412v-8.136c0-.286.143-.429.45-.429Z",
    transform: "translate(-610.261 -266.186)",
    fill: "#111"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1642",
    "data-name": "Group 1642",
    transform: "translate(21.039 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2354",
    "data-name": "Path 2354",
    d: "M795.753,288.47v2.984a9.169,9.169,0,0,0,.286,2.412,3.7,3.7,0,0,0,.982,1.614,3.83,3.83,0,0,0,1.7.879,9.968,9.968,0,0,0,2.537.286h8.654a.394.394,0,0,0,.45-.429v-1.881a.394.394,0,0,0-.45-.429h-8.593a5.413,5.413,0,0,1-1.268-.123,1.652,1.652,0,0,1-.818-.429,1.55,1.55,0,0,1-.409-.838,5.655,5.655,0,0,1-.121-1.235c.036,0,.072.005.111.005l6.6.018.023,0,.737,0,.986,0,.011-.006,2.509-.016c.354,0,.626-.125.626-.393v-2.027c0-.25-.338-.375-.692-.375",
    transform: "translate(-795.753 -282.889)",
    fill: "#111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2355",
    "data-name": "Path 2355",
    d: "M810.8,269.264a.4.4,0,0,0,.45-.45v-1.86a.4.4,0,0,0-.45-.429h-8.654a9.969,9.969,0,0,0-2.537.286,3.853,3.853,0,0,0-1.7.9,3.5,3.5,0,0,0-.963,1.545",
    transform: "translate(-796.951 -266.525)",
    fill: "#20c3ff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2356",
    "data-name": "Path 2356",
    d: "M7.128-38.5a6.517,6.517,0,0,1,.786.039,1.549,1.549,0,0,1,.55.167,1.849,1.849,0,0,1,.452.354,6.225,6.225,0,0,1,.491.6l7.311,9.59a.272.272,0,0,0,.255.138h.177q.157,0,.157-.2V-38.068a.382.382,0,0,1,.432-.432H19.8a.382.382,0,0,1,.432.432v11.28a2.279,2.279,0,0,1-.432,1.621,1.848,1.848,0,0,1-1.336.423h-1.69a6.069,6.069,0,0,1-.757-.039,1.682,1.682,0,0,1-.54-.157,1.8,1.8,0,0,1-.462-.344A5.9,5.9,0,0,1,14.5-25.9l-7.33-9.59a.337.337,0,0,0-.255-.138H6.735q-.157,0-.157.2v10.258a.382.382,0,0,1-.432.432H4.082q-.452,0-.452-.432v-11.28a2.279,2.279,0,0,1,.432-1.621A1.848,1.848,0,0,1,5.4-38.5Z",
    transform: "translate(37.64 38.5)",
    fill: "#111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2357",
    "data-name": "Path 2357",
    d: "M17.112-39.9q.452,0,.452.432v1.926a.4.4,0,0,1-.452.452H10.941v10.514a.382.382,0,0,1-.432.432H8.366a.382.382,0,0,1-.432-.432V-37.09H1.763a.4.4,0,0,1-.452-.452v-1.926q0-.432.452-.432Z",
    transform: "translate(60.998 39.9)",
    fill: "#111"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1647",
    "data-name": "Group 1647",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_9",
    "data-name": "Subtraction 9",
    d: "M9.787,13.756H.589A.523.523,0,0,1,0,13.167V11.026H9.708a5.743,5.743,0,0,0,1.454-.157,2.125,2.125,0,0,0,.953-.511,2.017,2.017,0,0,0,.521-.943,5.775,5.775,0,0,0,.157-1.454V5.8a5.768,5.768,0,0,0-.157-1.454,2.017,2.017,0,0,0-.521-.943,2.133,2.133,0,0,0-.953-.511,5.77,5.77,0,0,0-1.454-.157H8.184V2.724H0V.589A.522.522,0,0,1,.589,0h9.2a10.116,10.116,0,0,1,2.731.324,4.5,4.5,0,0,1,1.867,1,4.035,4.035,0,0,1,1.071,1.729A8.063,8.063,0,0,1,15.8,5.542V8.214a8.055,8.055,0,0,1-.344,2.486,4.039,4.039,0,0,1-1.071,1.73,4.5,4.5,0,0,1-1.867,1A10.14,10.14,0,0,1,9.787,13.756Z",
    fill: "#111"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_344",
    "data-name": "Rectangle 344",
    width: 2.896,
    height: 8.092,
    transform: "translate(0 5.664)",
    fill: "#111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1662",
    "data-name": "Group 1662",
    transform: "translate(133.156 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1645",
    "data-name": "Group 1645",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1648",
    "data-name": "Group 1648",
    transform: "translate(5.753 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_9-2",
    "data-name": "Subtraction 9",
    d: "M9.787,13.756H.589A.523.523,0,0,1,0,13.167V11.026H9.708a5.743,5.743,0,0,0,1.454-.157,2.125,2.125,0,0,0,.953-.511,2.017,2.017,0,0,0,.521-.943,5.775,5.775,0,0,0,.157-1.454V5.8a5.768,5.768,0,0,0-.157-1.454,2.017,2.017,0,0,0-.521-.943,2.133,2.133,0,0,0-.953-.511,5.77,5.77,0,0,0-1.454-.157H8.184V2.724H0V.589A.522.522,0,0,1,.589,0h9.2a10.116,10.116,0,0,1,2.731.324,4.5,4.5,0,0,1,1.867,1,4.035,4.035,0,0,1,1.071,1.729A8.063,8.063,0,0,1,15.8,5.542V8.214a8.055,8.055,0,0,1-.344,2.486,4.039,4.039,0,0,1-1.071,1.73,4.5,4.5,0,0,1-1.867,1A10.14,10.14,0,0,1,9.787,13.756Z",
    transform: "translate(0 0)",
    fill: "#111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2373",
    "data-name": "Path 2373",
    d: "M0,0H2.9V6.474H0Z",
    transform: "translate(0 5.342)",
    fill: "#111"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_361",
    "data-name": "Rectangle 361",
    width: 2.671,
    height: 10.252,
    rx: 1.335,
    transform: "translate(0 3.662)",
    fill: "#20c3ff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2381",
    "data-name": "Path 2381",
    d: "M1.362,2.721a1.36,1.36,0,1,1,1.361-1.36A1.361,1.361,0,0,1,1.362,2.721Z",
    transform: "translate(2.721 0) rotate(90)",
    fill: "#50f5ae"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToplogo);
export default __webpack_public_path__ + "static/media/toplogo.b2ac8506c592426c80e43ef7ec6cffb8.svg";
export { ForwardRef as ReactComponent };